import Sensores from './Sensores';
export default Sensores;
